import { Component, Injector, Input, forwardRef, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NgControl
} from '@angular/forms';
import { InputClass } from '@app/core/classes/input';
import { CalendarTypeView } from 'primeng/calendar';

const INPUT_CONTROL_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AmnInputDateComponent),
  multi: true
};

@Component({
  selector: 'app-amn-input-date',
  templateUrl: './amn-input-date.component.html',
  styleUrls: ['./amn-input-date.component.scss'],
  providers: [INPUT_CONTROL_ACCESSOR]
})
export class AmnInputDateComponent
  extends InputClass
  implements ControlValueAccessor, OnInit
{
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() type: string = 'Date';
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() showTime: boolean = false;
  @Input() view: CalendarTypeView = 'date';

  public ngControl!: NgControl;
  public isDisabled: boolean = false;

  constructor(private injector: Injector) {
    super();
  }

  ngOnInit() {
    Promise.resolve().then(
      () => (this.ngControl = this.injector.get(NgControl))
    );
  }

  onValueChanged() {
    this.updateValue(this.value);
  }

  dateFormat = 'dd M yy';

  hasError(errorCode: string): boolean | null {
    return (
      this.ngControl.enabled &&
      this.ngControl.hasError(errorCode) &&
      this.ngControl.dirty
    );
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
